import { useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, Product, PRODUCT, Products } from '@/core';

export const useProducts = ({
  page,
  limit,
  sortBy,
  sortOrder,
}: {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: string;
}) => {
  const fullUrl = `${ADMIN_API_URL_SUBPATH}/${PRODUCT}`;

  const useProductsSearch = (search: string) =>
    useQuery<Product[]>({
      queryKey: ['productsSearch', search],
      queryFn: async () => {
        const response = await axiosInstance.get(`${fullUrl}/search`, { params: { name: search } });
        return response.data;
      },
    });

  const useProductsQuery = useQuery<Products>({
    queryKey: ['products', page, limit, sortBy, sortOrder],
    queryFn: () =>
      axiosInstance
        .get(fullUrl, { params: { page, limit, sort_by: sortBy, sort_order: sortOrder } })
        .then((res) => res.data),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: true,
    enabled: true,
  });

  return {
    useProductsQuery,
    useProductsSearch,
  };
};
